import {
  ascend,
  compose,
  descend,
  equals,
  length,
  prop,
  reverse,
  sort,
  sortBy,
  toLower,
} from "ramda";

export const comparator = order => orderBy => {
  return equals(order, "asc") ? sortByAsc(orderBy) : sortByDesc(orderBy);
};

export const isActive = status => equals(status, "ACTIVE");

export const isAdminView = view => equals(view, "admin");

export const isCreatorManagerView = view => equals(view, "creatorManager");

export const formatItemType = type => {
  switch (toLower(type)) {
    case "anthology":
      return "anthology";
    case "collection":
      return "collection";
    default:
      return toLower(type);
  }
};

export const formatItemTypePath = type => {
  switch (toLower(type)) {
    case "anthology":
      return "anthologies";
    case "collection":
      return "collections";
    case "module":
      return "modules";
    case "content":
      return "content";
    default:
      return "content";
  }
};

export const formatSubscriptionStatus = subscribable =>
  subscribable ? "Subscribable" : "Not Subscribable";

export const sortByAsc = orderBy =>
  equals(orderBy, "name")
    ? sortBy(compose(toLower, prop(orderBy)))
    : equals(orderBy, "auditUpdated")
    ? sort(ascend(prop("auditUpdated")))
    : sort(ascend(compose(length, prop(orderBy))));

export const sortByDesc = orderBy =>
  equals(orderBy, "name")
    ? compose(reverse, sortBy(compose(toLower, prop(orderBy))))
    : equals(orderBy, "auditUpdated")
    ? sort(descend(prop("auditUpdated")))
    : sort(descend(compose(length, prop(orderBy))));
